module.exports = __webpack_public_path__ + "static/web-chat-77d313358402463e0ec7f843acdb5936.svg";